import React from 'react'
import { Grid, Icon } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector,useDispatch } from 'react-redux'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import { validation } from '../../util/cdsFieldPatterns';
import {addPartiesTabWarnings,deletePartiesTabWarnings} from "../../actions/errorValidationActions";

const GuaranteeDetails = ({
  item: {id,type,ref,amount,currency,refID,accessCode,office },
  deleteData,
  updateData,
  saveData,
}) => {
  const dan1 = useSelector((state) => state.Actor.dan1) || ''
  const guaranteeType = useSelector((state) => state.DropDownValues.guaranteeType)
  const currencyTypes=useSelector((state) => state.DropDownValues.currencyTypes) || [];
  const {declarationCat = ''} = useSelector((state) => state.Shipment) || []
  const dispatch = useDispatch()

  const deleteMultiAuthorisations = async (id, type) => {
    const res = await saveData({ id, type: type || ' ' })

    if (!!res?.form?.parties?.authorization?.length) {
      const idsToDelete = res?.form?.parties?.authorization?.map((item) => item.id) || []
      dispatch({
        type: 'DELETE_ITEM_MULTI_PARTIES',
        payload: idsToDelete,
        meta: { tableName: 'authorization' },
      })
    }
    return
  }


  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'partiesTab'),
    [declarationCat]
  )
  const addErrors = (level, value, fieldName) => {
    dispatch(addPartiesTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deletePartiesTabWarnings(level, value, fieldName))
  }


  const isFormDisabled = false
  return (
    <>
      <Grid.Row>
        <Grid.Column width='8' className='divFormFeild border-bottom b-rw-0'>
          <DropDown
            id={`guaranteeType${id}`}
            label='Guarantee Type'
            boxNumber='8/2'
            disabled={isFormDisabled}
            className='field-bg dropdown100 addInfoCode'
            labelClass='text-none'
            isLabel={true}
            data={guaranteeType}
            clearable
            value={type}
            onChange={async(value) => {
              updateData(id, { type: value?.trim() })
              if (!!value && value == 0) {
                const res = await saveData({ id, type: value || ' ' })
                let refId = res?.form?.parties?.guarantee?.[0].refID;
                updateData(id, { refID: refId || "GUARANTEENOTREQUIRED" })
                if (!!res?.form?.parties?.authorization?.length)
                  dispatch({
                    type: `ADD_ITEM_MULTI_PARTIES`,
                    payload: res?.form?.parties?.authorization || [],
                    meta: { tableName: 'authorization' },
                  })
                return
              } else if(!value || value !=0 && refID === 'GUARANTEENOTREQUIRED'){
                updateData(id, { refID: "" })
                deleteMultiAuthorisations(id, value)
               }
              saveData({ id, type: value || ' ' })
            }}
          />
        </Grid.Column>
        <Grid.Column width='7' className='divFormFeild border-bottom'>
          <InputField
            isLabel={false}
            id={`guaranteeReference${id}`}
            type='text'
            label='Guarantee Reference'
            boxNumber='8/3'
            value={ref}
            errors={getValidationError("guaranteeref",ref)}
            className={'field-bg'}
            clearInput={false}
            onChange={(value) => updateData(id, { ref: value })}
            onBlur={(value) => {saveData({ id, ref:ref||' ' })
            let err = getValidationError('guaranteeref', ref,'partiesTab')
                err.length
                  ? addErrors('partiesTab', err[0], 'guaranteeref')
                  : deleteErrors('partiesTab', '', 'guaranteeref')
          }}
            disabled={isFormDisabled}
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width='3' className='divFormFeild border-bottom b-rw-0'>
          <InputField
            isLabel={false}
            id={`guaranteeAmount${id}`}
            type='text'
            label='Guarantee Amount'
            value={amount}
            errors={getValidationError("guaranteeamount",amount || " ")}
            className={'field-bg'}
            clearInput={false}
            onChange={(value) => updateData(id, { amount: value })}
            onBlur={(value) => {saveData({ id, amount: amount || ' ' })
            let err = getValidationError('guaranteeamount', amount,'partiesTab')
                err.length
                  ? addErrors('partiesTab', err[0], 'guaranteeamount')
                  : deleteErrors('partiesTab', '', 'guaranteeamount')
          }}
            disabled={isFormDisabled}
          />
        </Grid.Column>
        <Grid.Column width='3' className='divFormFeild border-bottom b-rw-0'>
          <DropDown
            id={`currency${id}`}
            label='Currency'
            disabled={isFormDisabled}
            className='field-bg dropdown100'
            labelClass='text-none'
            isLabel={true}
            data={currencyTypes}
            value={currency}
            clearable
            onChange={(value) => {
              saveData({ id, currency: value || ' ' })
              updateData(id, { currency: value?.trim() })
            }}
          />
        </Grid.Column>
        <Grid.Column width='3' className='divFormFeild border-bottom b-rw-0'>
          <InputField
            isLabel={false}
            id={`guaranteeRefId${id}`}
            type='text'
            label='Guarantee Ref Id'
            value={refID}
            className={'field-bg'}
            clearInput={false}
            clearable
            onChange={(value) => updateData(id, { refID: value })}
            onBlur={(value) => saveData({ id, refID: refID || ' ' })}
            disabled={isFormDisabled}
          />
        </Grid.Column>
        <Grid.Column width='3' className='divFormFeild border-bottom b-rw-0'>
          <InputField
            isLabel={false}
            id={`accessCode${id}`}
            type='text'
            label='Access Code'
            value={accessCode}
            className={'field-bg'}
            clearInput={false}
            clearable
            onChange={(value) => updateData(id, { accessCode: value })}
            onBlur={(value) => saveData({ id, accessCode: accessCode || ' ' })}
            disabled={isFormDisabled}
          />
        </Grid.Column>
        <Grid.Column width='3' className='divFormFeild border-bottom'>
          <InputField
            isLabel={false}
            id={`guaranteeOffice${id}`}
            type='text'
            label='Guarantee Office'
            value={office}
            className={'field-bg'}
            clearInput={false}
            clearable
            onChange={(value) => updateData(id, { office: value })}
            onBlur={(value) => saveData({ id, office: office || ' ' })}
            disabled={isFormDisabled}
          />
        </Grid.Column>

        <Grid.Column width='1' className='icon-delete-add-info'>
          <DeleteIcon id={`deleteGuarantee${id}`} onClick={() => deleteData(id)} />
        </Grid.Column>
      </Grid.Row>
    </>
  )
}

export default React.memo(GuaranteeDetails)
